import React, { useEffect } from "react";
import { Form, Button, Typography, Input, Grid, Flex } from "antd";
import { App } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRacksList, createOrUpdateRack } from "../racksThunks";
import { setSelectedRack, setIsEditRack } from "../racksSlice";
import InputField from "../../../components/Input/Input";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateRackForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const screens = useBreakpoint();

  const { isEditRack, selectedRack } = useSelector((state) => state.racks);

  useEffect(() => {
    if (isEditRack && selectedRack) {
      form.setFieldsValue(selectedRack);
    } else {
      form.resetFields();
    }
  }, [isEditRack, selectedRack, form]);

  const handleCancel = () => {
    dispatch(setSelectedRack(null));
    dispatch(setIsEditRack(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      await dispatch(
        createOrUpdateRack({
          ...values,
          action: isEditRack ? "update" : "create",
          id: selectedRack?.id || selectedRack?.rack_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditRack
          ? "Rack updated successfully"
          : "Rack created successfully",
      });

      dispatch(setSelectedRack(null));
      dispatch(setIsEditRack(false));
      navigate("/inventory/racks-manage");
      dispatch(fetchRacksList());
    } catch (error) {
      modal.warning({
        title: error.message || "Save failed",
      });
    }
  };

  return (
    <div className="rack-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {isEditRack ? "Update Rack" : "Create New Rack"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Rack Name"
              name="name"
              rules={[{ required: true, message: "Please enter rack name" }]}
            >
              <InputField placeholder="Enter Rack Name" />
            </Form.Item>
          </Flex>
        </Flex>
        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button onClick={handleCancel} style={{ marginRight: "12px" }} className="traic-button">
            Back
          </Button>
          <Button type="primary" htmlType="submit" className="traic-button">
            {isEditRack ? "Update" : "Save"}
          </Button>
        </Flex>
      </Form>
    </div>
  );
};

export default CreateRackForm;
